import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  menuregisterButton: {
    color: '#0C4C35',
    border: '1px solid #0C4C35',
    '&:hover': {
      color: '#63D764',
      border: '1px solid #63D764',
    },
    marginTop: 4,
    padding: '2px 20px 2px 20px',
  },
});

export default function RegisterButton(props) {
  const classes = useStyles();
  const {onClick} = props;

  return (
    <div>
      <Button href="/register" className={classes.menuregisterButton} variant="outlined" onClick={onClick} >
        <Box p={1} fontWeight="fontWeightBold" fontSize={16}>Register</Box>
      </Button>
    </div>
  );
}